import React from "react";
import lightmodeillustration from "./assets/lightmodeillsutration.png";
import darkmodeillustration from "./assets/darkmodeillustration.png";

const NoDataFound = ({ mode, activeFilterCount = 0, onReset }) => {
  const isFiltered = activeFilterCount > 0;
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        flexDirection: "column",
        backgroundColor: mode === "dark" ? "#1E1E1E" : "white",
      }}
    >
      <img
        src={mode === "dark" ? darkmodeillustration : lightmodeillustration}
        height="25%"
        width="25%"
        alt="Not found"
      />
      <h4
        style={{
          color: mode === "dark" ? "white" : "black",
          padding: isFiltered ? "20px 20px 8px" : "20px",
        }}
      >
        {isFiltered ? "No contracts match your filters" : "No Search Found!"}
      </h4>
      {isFiltered && (
        <>
          <p
            style={{
              color: mode === "dark" ? "#c9c9c9" : "#5a6472",
              margin: "0 0 14px",
              fontSize: "13px",
            }}
          >
            {activeFilterCount} filter{activeFilterCount === 1 ? " is" : "s are"}{" "}
            active. Contracts outside {activeFilterCount === 1 ? "it" : "them"}{" "}
            are hidden, not deleted.
          </p>
          {onReset && (
            <button
              className="thead-buttons"
              style={{
                backgroundColor: mode === "dark" ? "#2B2B2B" : "#e8eaec",
                color: mode === "dark" ? "#fff" : "#3A4450",
                border: mode === "dark" ? "1px solid #4C4C4C" : "none",
                marginBottom: "20px",
              }}
              onClick={onReset}
            >
              Reset All Filters
            </button>
          )}
        </>
      )}
    </div>
  );
};

export default NoDataFound;
